import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { borderRadius, styled } from "@mui/system";
import { t } from "i18next";
import { Stack } from "@mui/material";
import "./TabUserLevel.css";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const StyledTabs = styled(Tabs)(({ theme }) => {
  return {
    display: "inline-flex",
    border: "1px solid #8E2DE2",
    borderRadius: "50px",
    width: "100%",
    padding: "5px 0",
    justifyContent: "space-between",
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& 	.MuiTabs-flexContainer": {
      padding: "0",
      width: "100%",
      justifyContent: "space-between",
    },
    "& .MuiTabs-fixed": {
      padding: "0 15px",
    },
    "& .MuiButtonBase-root": {
      width: "10rem",
    },
  };
});
const StyledTab = styled(Tab)(({ theme }) => {
  return {
    "&.Mui-selected": {
      background: "#FF3DFF",
      borderRadius: "50px",
      color: "#fff",
      width: "10rem",
    },
  };
});

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            py: 3,
            px: 0.5,
            bgcolor: "background.darkBlack",
            color: "text.primary",
          }}
        >
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TabsUserLevel() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", my: 4 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <StyledTab label={`${t("level_1")}`} {...a11yProps(0)} />
          <StyledTab label={`${t("level_2")}`} {...a11yProps(1)} />
          <StyledTab label={`${t("level_3")}`} {...a11yProps(2)} />
          <StyledTab label={`${t("level_4")}`} {...a11yProps(3)} />
        </StyledTabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Stack direction={{ xs: "row", md: "column" }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={{ xs: "space-around", md: "space-between" }}
            sx={{
              bgcolor: "#1B1C31",
              borderRadius: "10px",
              py: 1,
              px: 2,
              alignItems: { xs: "start", md: "center" },
            }}
          >
            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("forms_needed")}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("access")}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("limitations")}
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={"space-between"}
            sx={{ py: 1, px: 2, alignItems: { xs: "start", md: "center" } }}
          >
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  شماره همراه
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  ایمیل
                </Typography>
              </li>
            </ul>
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  خرید پایه
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  سقف روزانه ۳ میلیون تومان
                </Typography>
              </li>
            </ul>
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  ارز های محدود
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  خرید روزانه و ماهانه محدود
                </Typography>
              </li>
            </ul>
          </Stack>
        </Stack>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Stack direction={{ xs: "row", md: "column" }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={{ xs: "space-around", md: "space-between" }}
            sx={{
              bgcolor: "#1B1C31",
              borderRadius: "10px",
              py: 1,
              px: 2,
              alignItems: { xs: "start", md: "center" },
            }}
          >
            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("forms_needed")}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("access")}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("limitations")}
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={"space-between"}
            sx={{ py: 1, px: 2, alignItems: { xs: "start", md: "center" } }}
          >
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  ایمیل
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  شماره همراه
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  تلفن ثابت
                </Typography>
              </li>
            </ul>
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  سقف خرید روزانه ۵ میلیون تومان
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  دسترسی به ۱۰۰ ارز
                </Typography>
              </li>
            </ul>
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  دسترسی نداشتن به همه ارز های پارسیان بیت
                </Typography>
              </li>
            </ul>
          </Stack>
        </Stack>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Stack direction={{ xs: "row", md: "column" }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={{ xs: "space-around", md: "space-between" }}
            sx={{
              bgcolor: "#1B1C31",
              borderRadius: "10px",
              py: 1,
              px: 2,
              alignItems: { xs: "start", md: "center" },
            }}
          >
            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("forms_needed")}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("access")}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("limitations")}
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={"space-between"}
            sx={{ py: 1, px: 2, alignItems: { xs: "start", md: "center" } }}
          >
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  شماره همراه
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  ایمیل
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  تلفن ثابت
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  عکس کارت ملی
                </Typography>
              </li>
            </ul>
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  دسترسی به همه ارز های پارسیان بیت
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  سقف خرید روزانه ۱۵ میلیون تومان
                </Typography>
              </li>
            </ul>
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  محدودیت سقف خرید
                </Typography>
              </li>
            </ul>
          </Stack>
        </Stack>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Stack direction={{ xs: "row", md: "column" }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={{ xs: "space-around", md: "space-between" }}
            sx={{
              bgcolor: "#1B1C31",
              borderRadius: "10px",
              py: 1,
              px: 2,
              alignItems: { xs: "start", md: "center" },
            }}
          >
            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("forms_needed")}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("access")}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              my={{ xs: 3, md: 0 }}
            >
              {t("limitations")}
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent={"space-between"}
            sx={{ py: 1, px: 2, alignItems: { xs: "start", md: "center" } }}
          >
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  شماره همراه
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  ایمیل
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  تلفن ثابت
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  عکس کارت ملی
                </Typography>
              </li>
            </ul>
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  دسترسی به همه ارز های پارسیان بیت
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  بدون محدودیت سقف برداشت
                </Typography>
              </li>
            </ul>
            <ul className="ul_tab_user_level">
              <li>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.secondary"
                  my={{ xs: 3, md: 0 }}
                >
                  بدون محدودیت
                </Typography>
              </li>
            </ul>
          </Stack>
        </Stack>
      </TabPanel>
    </Box>
  );
}
